export default "assets/images/icons/facebook-0867bee8.svg";